import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';
import { updateContactCategory } from '../api/contactCategories';
import type { ContactCategoryFormValues } from '../types';

export function useUpdateContactCategory(categoryId: number | null, onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: ContactCategoryFormValues) => {
      if (categoryId === null) {
        throw new Error('Category id is required');
      }
      return updateContactCategory(categoryId, data);
    },
    onSuccess: () => {
      notification.success({ message: 'Contact category updated successfully' });
      void queryClient.invalidateQueries({ queryKey: ['settings-contact-categories'] });
      void queryClient.invalidateQueries({ queryKey: ['contact-categories'] });
      onSuccess?.();
    },
    onError: () => {
      notification.error({ message: 'Failed to update contact category' });
    },
  });
}
